import { theme } from '../../styles/theme';

export const TestsTableContainer = {
  background: theme.palette.common.white,
  borderBottom: 0
};

export const TestsTableTHead = {
  background: theme.palette.common.lightGrey5,
  fontWeight: 600,
  border: 0
};

export const TestsTableTHeadTableRow = {
  '> th: last-child': {
    textAlign: 'center'
  }
};

export const ResultsTableHeaderCellStyle = {
  border: 0,
  fontWeight: 600,
  minWidth: 'auto'
};

export const TitleAndDate = {
  display: 'flex',
  flexFlow: 'column',
  fontSize: '14px',
  fontWeight: 400
};

export const TestsTableTBody = {
  td: {
    height: '69px'
  }
};

export const HideLastRowBorder = {
  '&:last-of-type': {
    td: {
      border: 0
    }
  }
};

/** Main data row when a details row follows — avoids a double line between the pair */
export const HideRowBottomBorder = {
  td: {
    borderBottom: 0
  }
};

export const getLicenseTableRowSx = (
  multipleLicenses: boolean,
  hasFollowingDetailsRow: boolean,
  clickableRow: boolean
) => [
  multipleLicenses ? HideLastRowBorder : {},
  hasFollowingDetailsRow ? HideRowBottomBorder : {},
  {
    cursor: clickableRow ? 'pointer' : ('default' as const)
  }
];

export const TestsTableTestCell = {
  display: 'flex',
  alignItems: 'center',
  fontSize: '16px',
  fontWeight: 600,
  img: {
    marginRight: '16px'
  }
};

export const HideResultsTableColumnOnTablet = {
  [theme.breakpoints.down('tablet')]: {
    display: 'none !important'
  }
};

export const TestsTableOverallCell = {
  fontSize: '16px',
  fontWeight: 600,
  width: '200px',
  textAlign: 'left',
  ...HideResultsTableColumnOnTablet
};

export const TestsTableArrowCellImage = {
  height: '15px'
};

export const ResultsTestTableEmptyCell = {
  textAlign: 'center',
  borderBottom: 0
};
